import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFoundPage() {
  return (
    <section className="min-h-[70vh] pt-40 pb-24 bg-bone-100 flex items-center">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div className="font-display text-[8rem] md:text-[12rem] leading-none text-sage-300 italic">404</div>
        <h1 className="mt-6 font-display font-light text-4xl md:text-5xl text-ink-900 tracking-[-0.03em]">
          Diese Seite ist <span className="italic">noch unterwegs</span>.
        </h1>
        <p className="mt-5 text-ink-700 max-w-xl mx-auto">
          Vielleicht wurde sie verschoben — oder es gibt sie (noch) nicht. Lass uns einfach woanders weitermachen.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 text-[13px] tracking-[0.14em] uppercase font-mono-fine text-ink-900 link-underline"
        >
          <ArrowLeft strokeWidth={1.5} className="w-4 h-4" /> Zurück zur Startseite
        </Link>
      </div>
    </section>
  );
}
